// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyBEKSG6vP5KD6R0OFZwyYiUCB_s1gHGGpA",
    authDomain: "choosetoprint-1b672.firebaseapp.com",
    projectId: "choosetoprint-1b672",
    storageBucket: "choosetoprint-1b672.firebasestorage.app",
    messagingSenderId: "589252232116",
    appId: "1:589252232116:web:388da5dcd6543ca1d4a8e1",
    measurementId: "G-WP9WTTG16Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

export { db };
